import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './components/App/App';
import Populate from './components/Populate/Populate';
import Reader from './components/Reader/Reader';
import { LoginForm, SignupForm, GoogleCallback } from './components/Auth';
import { AuthProvider, ProtectedRoute } from './auth';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<App />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/signup" element={<SignupForm />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />

          {/* Protected routes */}
          <Route path="/populate" element={
            <ProtectedRoute>
              <Populate />
            </ProtectedRoute>
          } />
          <Route path="/reader" element={
            <ProtectedRoute>
              <Reader />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
